import { BILLING_TYPE_MAP } from '@constants/billing';
import { getDifferenceInDates } from '@helpers/dates';

export const updateAccountSubscriptions = (subscriptions, onboardingCompleted = true) => {
    return subscriptions.map(subscription => {
        const expiredAtDate = new Date(subscription.expiresAt);
        const isTrial = subscription?.billingPlanName === BILLING_TYPE_MAP.TRIAL;
        if (!isTrial) {
            expiredAtDate.setDate(expiredAtDate.getDate() + 30);
        }
        let { billingDiffInDays } = getDifferenceInDates(expiredAtDate, isTrial ? 0 : 30);
        if (!onboardingCompleted) {
            billingDiffInDays = 0;
        }
        return { ...subscription, billingDiffInDays };
    });
};
